// @flow
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import ReduxToastr from "react-redux-toastr";

import RouterComp from "./route";
import HeaderWrapper from "../components/wrappers/headerWrapper/headerWrapper";
// import FooterWrapper from "../components/wrappers/footerWrapper/footerWrapper";

import { getUserProfile } from "../services/authService/authActionCreator";
import Loader from "../components/commons/loader/loader";

type Props = {
  userProfile?: Object,
  getUserProfile: Function,
  history: Object
};

const loadingText = "Loading Ticketing...";

class App extends React.Component<Props> {
  componentDidMount() {
    this.props.getUserProfile();
  }

  render() {
    if (this.props.userProfile) {
      // eslint-disable-next-line no-console
      // console.log("User {}", this.props.userProfile);
      return (
        <div className="app-wrapper">
          <HeaderWrapper history={this.props.history} />
          <RouterComp
            userProfile={this.props.userProfile}
            history={this.props.history}
          />
          {
            // <FooterWrapper />
          }
          <ReduxToastr
            timeOut={4000}
            newestOnTop={true}
            preventDuplicates
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
          />
        </div>
      );
    }
    return <Loader message={loadingText} />;
  }
}

App.defaultProps = {
  userProfile: null
};

const mapStateToProps = state => ({
  userProfile: state.userProfile
});

const mapDispatchToProps = dispatch => ({
  getUserProfile: bindActionCreators(getUserProfile, dispatch)
  // logout: bindActionCreators(logout, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./app/main/app.js